import script from "./FormRadioTariffCard.vue?vue&type=script&setup=true&lang=js"
export * from "./FormRadioTariffCard.vue?vue&type=script&setup=true&lang=js"

import "./FormRadioTariffCard.vue?vue&type=style&index=0&id=89939546&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89939546"]])

export default __exports__